
import React from 'react';
import { Link } from 'react-router-dom';
import '../scripts/useHoverEffect';
import DriverModal from '../components/DriverModal';
import HomePhoto from "../components/HomePhoto";
import MapComponent from '../components/MapComponentMain';
import '../css/mainlockup.css';
import '../css/driver-modal.css';
import '../css/main.css';


const HomeDesktopLayout: React.FC = () => {
    return (
<div className='hero'>
          {/* Column 1*/}
        <div className='hero-column-1'>

          {/* Column 1 Row 1 */}
          <div className='main-lockup' id='hero-title'>
            
            <div className='main-lockup-text'>
              <h1 > 
              Szukasz szybkiej i niezawodnej taksówki w Bochni?
              </h1>
              <h2 >
              Oferujemy usługi taxi, dzięki którym zawsze dotrzesz na czas! Nasi profesjonalni kierowcy zapewniają bezpieczne i komfortowe przejazdy w konkurencyjnych cenach.
              Zarezerwuj swoją taksówkę już teraz i ciesz się bezproblemową podróżą!
              </h2>
            </div>
          </div>

          {/* Column 1 Row 2 */}
          <div className='side-lockup' id='desktop-side-lockup'>

            <div className='driver-modal-container'>
              {/* Render modal for the first driver */}
              <DriverModal driverIndex={1} />

              {/* Render modal for the second driver */}
              <DriverModal driverIndex={2} />
            </div>
          </div>

        </div>
        {/* Column 2*/}
        <div className='hero-column-2'>

        {/* Column 2 Row 1 */}
        <HomePhoto/>

        {/* Column 2 Row 2 */}
        <div className='main-lockup-services'>
          <h2>
              Wśród naszych dodatkowych usług znajdziesz również: 
          </h2>
          <ul>
            <li>
              Transport na lotniska.
            </li>
            <li>
              Transport imprez okolicznościowych.
            </li>
            <li>
              Bezpieczny transport dla najmłodszych <br/> między placówkami edukacyjnymi a domem.
            </li>
          </ul>
          <p className='more-info'>
            Po więcej informacji zapraszamy na stronę <Link to="/services" className='custom-link'>usługi.</Link>
          </p>
          <div className='main-lockup-buttons-container'>

              <h2>
              Zadzwoń i zamów taksówkę już teraz!
              </h2>
              <div className='buttons-flex'>
                <div className='main-lockup-button'>
                  <a rel="nofollow" href='https://maps.app.goo.gl/odSG4ixFKZLV9mAj6'>
                    Bogdan: 669 102 202
                  </a>
                </div>
                <div className='main-lockup-button'>
                  <a rel="nofollow" href='https://maps.app.goo.gl/vfTBNTVDNXCRAqTZ8'>
                  Robert: 534 014 014
                  </a>
                </div>
              </div>
            </div>
        </div>
        


        </div>
        <div className='main-lockup-map-container'>
              <div className='main-lockup-map-title'>
                <div>
                  <h3> BOCHNIA - Postój taksówek </h3>
                  <p> Dominikańska 1, 32-700 Bochnia, Poland</p>
                </div>
                <div>
                  <p>
                    Przejdź na <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer" className='custom-link'>Google Maps</a>.
                  </p>
                </div>
              </div>

              <MapComponent/>
        </div>
        </div>
    );
};

export default HomeDesktopLayout